module.exports = {
  not_found_title: "404エラー",
  not_found_sub_title: "お探しページは見つかりません。",
  not_found_button: "xIDサイトへ",

  mobile_launch_app_title: "xIDを起動する",
  mobile_launch_app_button: "アプリを起動する",
  mobile_launch_app_dont_have_account: "xIDのアカウントはまた持ってない？",
}
